var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99996,
    cy: 10.4998,
    r: 8.33333,
    stroke: "#5801FF",
    strokeWidth: 1.42857
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 8.00016C8.33337 7.07969 9.07957 6.3335 10 6.3335C10.9205 6.3335 11.6667 7.07969 11.6667 8.00016C11.6667 8.33196 11.5698 8.6411 11.4026 8.90082C10.9045 9.67489 10 10.413 10 11.3335V11.7502",
    stroke: "#5801FF",
    strokeWidth: 1.42857,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99337 14.6665H10.0009",
    stroke: "#5801FF",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.be3ce9d724233795abc425606539a240.svg";
export { ForwardRef as ReactComponent };